<template>
    <span>
        <input type="text"
               ref="input"
               :size="size"
               v-bind:value="value"
               v-on:input="updateValue($event.target.value)"
               v-bind:class="{ 'dirtyInput': isDirty, 'invalidInput': !isValid }"
               @keyup.up="increment"
               @keyup.down="decrement"
               @focus="$event.target.select()"
        /><small>{{suffix}}</small>
        <span v-if="!isValid" class="helpText"><BR/>{{this.helpText}}</span>
    </span>
</template>

<script>
    export default {
        name: 'elv-user-editable-input',
        props: {
            'playerId': {required:true},
            'fieldName': {required:true},
            'size': {default:1, required: false},
            'value': {required: true},
            'step': {default: 1, required: false, type: Number},
            'max': {default: 6, required: false, type: Number},
            'min': {default: 1, required: false, type: Number},
            'suffix': {default: "/day"},
            'helpText': {default: "Must be 1 -> 6", required: false},
        },
        data() {
            return {
                compIdentifier: 'elv-user-editable-input',
                isDirty: false,
                isValid: true,
                originalValue: "",
            }
        },
        created() {
            //console.log("Setting original value to: " + this.value);
            this.originalValue = this.value;
        },
        methods: {
            increment: function() {
                if( this.value + this.step > this.max ) {
                    this.updateValue( this.max );
                }else {
                    this.updateValue( this.value + this.step );
                }
            },
            decrement: function() {
                if( this.value === "NaN" || isNaN(this.value) ) {
                    this.updateValue(this.min);
                }
                if( this.value - this.step < this.min  ) {
                    this.updateValue(this.min);
                }else {
                    this.updateValue( this.value - this.step);
                }
            },
            updateValue: function (value) {
                try {
                    value = Number(value);
                    this.isDirty = value !== this.originalValue;
                    //console.log(value, this.value, this.isDirty, this.original);
                    if( value < this.min || value > this.max ) {
                        this.isValid = false;
                        console.log("NOT VALID")
                        //value = 4;
                    }
                    else {
                        this.isValid = true;
                    }
                }catch(err) {
                    this.isValid = false;
                }

                this.$refs.input.value = value;
                // Emit the number value through the input event
                this.$emit('input', Number(value))

                // var formattedValue = value
                // // Remove whitespace on either side
                //     .trim()
                //     // Shorten to 2 decimal places
                //     .slice(
                //         0,
                //         value.indexOf('.') === -1
                //             ? value.length
                //             : value.indexOf('.') + 3
                //     )
                // // If the value was not already normalized,
                // // manually override it to conform
                // if (formattedValue !== value) {
                //     this.$refs.input.value = formattedValue
                // }


            }
        }
    };
</script>

<style scoped>
    input[type="text"], input[type="number"] {
        text-align: right;
        padding-right: 4px;
        border: 1px solid #DDDDDD;
    }

    .dirtyInput {
        color: darkorange;
        font-weight: bold;
    }
    .invalidInput {
        background-color: palevioletred;
        color: black;
    }
    .helpText {
        color: darkred;
        font-size: 9pt;
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvUserEditableInput.vue